<script setup>
  import ComponentIcon from "@components/Icons/Icon.vue";

  defineOptions({
    name: "IconButton",
  });

  defineProps({
    icon: {
      type: String,
      default: "call_to_action",
    },
    href: {
      type: String,
      default: null,
    },
  });

  defineEmits(["click"]);
</script>

<template>
  <component
    :is="href ? 'inertia-link' : 'button'"
    :href="href"
    :class="{'no-underline!': href}"
    class="p4umc-btn rounded-full"
    :data-test="getTestId(href ? 'inertia-link' : 'icon-button')"
    @click="$emit('click')"
  >
    <slot>
      <component-icon>{{ icon }}</component-icon>
    </slot>
  </component>
</template>
